import React from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { FailedMethods } from './components/FailedMethods';
import { Mechanism } from './components/Mechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsFor } from './components/WhoIsFor';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { OfferBlock } from './components/OfferBlock';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-dark font-inter" data-id="element-0">
      <Hero data-id="element-1" />
      <Problem data-id="element-2" />
      <FailedMethods data-id="element-3" />
      <Mechanism data-id="element-4" />
      <WhatYouGet data-id="element-5" />
      <WhoIsFor data-id="element-6" />
      <HowItWorks data-id="element-7" />
      <Proof data-id="element-8" />
      <FAQ data-id="element-9" />
      <OfferBlock data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}